module.exports = __webpack_public_path__ + "static/media/step-solution1.217e5966.svg";